"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptLibraryLoader = void 0;
const helpers_1 = require("../../../../core/helpers");
const scriptLoader_1 = require("../../../../core/script/scriptLoader");
class ScriptLibraryLoader {
    //TODO may be we will need a config by script url no by libraryr
    constructor(scriptName, scriptConfig) {
        this.scriptName = scriptName;
        this.urlsToLoad = [];
        this.scriptLoader = new scriptLoader_1.ScriptLoader(scriptConfig);
    }
    preload() {
        //May be overridden
    }
    postLoad() {
        //May be overridden
        return Promise.resolve();
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                helpers_1.Log.info(`ScriptLibrary - Loading script library ${this.scriptName}`);
                this.preload();
                this.urlsToLoad = this.getUrls();
                helpers_1.Log.info(`ScriptLibrary - Preloading correctly script library ${this.scriptName}`);
                const urlsLoaders = [];
                this.urlsToLoad.forEach((urlToLoad) => {
                    if (!this.scriptLoader.isScriptTagInDocument(urlToLoad)) {
                        urlsLoaders.push(this.scriptLoader.loadScript(urlToLoad));
                    }
                });
                Promise.all(urlsLoaders)
                    .then(() => __awaiter(this, void 0, void 0, function* () {
                    helpers_1.Log.info(`ScriptLibrary - Loaded correctly script library ${this.scriptName}`);
                    yield this.postLoad();
                    resolve(this.scriptName);
                }))
                    .catch((url) => {
                    helpers_1.Log.error(`ScriptLibrary - Can not load correctly script library ${this.scriptName} . Failed loading ${url}`);
                    reject(url);
                });
            });
        });
    }
}
exports.ScriptLibraryLoader = ScriptLibraryLoader;
//# sourceMappingURL=index.js.map